import { FormattedMessage } from 'react-intl';
import BugReportOutlined from '@mui/icons-material/BugReportOutlined';
import DoNotDisturbOnOutlined from '@mui/icons-material/DoNotDisturbOnOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import LockPersonOutlined from '@mui/icons-material/LockPersonOutlined';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';
import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

import { List, ListHeader, ListItemButton, ListItemNavLink, ListItemStartIcon, ListItemText, Paper } from '@ocx/ui';
import { openUrlInWindow } from '@ocx/utils-device';
import { logInDev } from '@ocx/utils';
import { CookieIcon } from '@ocx/ui-icons';

import { profileMessages as messages } from '../profile.messages';

export type AccountActionsListProps = {
  isDeleteAccountEnabled: boolean;
  isDevtoolsEnabled?: boolean;
  personalDataShareOptOut: { enabled: false } | { enabled: true; optOutUrl: string };
  cookieConsentEditing: { enabled: false } | { enabled: true; onEdit: () => void };
  onLogoutClick: () => void;
};

export const AccountActionsList = (props: AccountActionsListProps) => {
  const { isDeleteAccountEnabled, isDevtoolsEnabled, personalDataShareOptOut, cookieConsentEditing, onLogoutClick } =
    props;
  const { triggerEvent } = useRudderStack();

  return (
    <Paper sx={{ overflow: 'hidden', px: 0, pb: 0 }}>
      <ListHeader>
        <FormattedMessage {...messages['profile:accountSection:title']} />
      </ListHeader>

      <List>
        {personalDataShareOptOut.enabled && (
          <ListItemButton
            onClick={() => {
              openUrlInWindow({ url: personalDataShareOptOut.optOutUrl, nativeMode: 'systemBrowser' }).catch(logInDev);
              triggerEvent('personal_data_share_opt_out_link_clicked');
            }}>
            <ListItemStartIcon>
              <LockPersonOutlined />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:accountActions:personalDataShareOptOut']} />
            </ListItemText>
          </ListItemButton>
        )}
        {cookieConsentEditing.enabled && (
          <ListItemButton onClick={cookieConsentEditing.onEdit}>
            <ListItemStartIcon>
              <CookieIcon />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:cookieConsentEditing:editConsentButtonTitle']} />
            </ListItemText>
          </ListItemButton>
        )}
        {isDeleteAccountEnabled && (
          <ListItemNavLink to={AppRoutePath.DeleteAccount}>
            <ListItemStartIcon>
              <DoNotDisturbOnOutlined />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:accountActions:deleteAccountButtonTitle']} />
            </ListItemText>
          </ListItemNavLink>
        )}
        <ListItemButton onClick={onLogoutClick}>
          <ListItemStartIcon>
            <LogoutOutlined />
          </ListItemStartIcon>
          <ListItemText>
            <FormattedMessage {...messages['profile:accountActions:signOutButtonTitle']} />
          </ListItemText>
        </ListItemButton>
        {isDevtoolsEnabled && (
          <ListItemNavLink to={AppRoutePath.Devtools}>
            <ListItemStartIcon>
              <BugReportOutlined />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:accountActions:devtoolsButtonTitle']} />
            </ListItemText>
          </ListItemNavLink>
        )}
      </List>
    </Paper>
  );
};
